import type { UUID } from '@shared/api';
import { pickLocalized, type Locale, type LocalizedString } from '@shared/i18n';

export type CategoryKind = 'PRODUCER' | 'ECO_PRODUCER' | 'PRODUCT';

/** @deprecated Use LocalizedString from @shared/i18n. Kept for backwards-compat. */
export type LocalizedName = LocalizedString;

export interface Category {
  id: UUID;
  kind: CategoryKind;
  parentId: UUID | null;
  slug: string;
  name: LocalizedString;
  sortOrder: number;
}

export interface CategoryCreate {
  kind: CategoryKind;
  parentId: UUID | null;
  slug: string;
  name: LocalizedString;
  sortOrder: number;
}

export interface CategoryUpdate {
  name: LocalizedString;
  sortOrder: number;
}

export interface CategoryUsage {
  manufacturers: number;
  products: number;
  buyRequests: number;
}

export interface HsCode {
  code: string;
  description: string;
}

export const CATEGORY_KINDS: CategoryKind[] = ['PRODUCER', 'ECO_PRODUCER', 'PRODUCT'];

export const LOCALES: Locale[] = ['ru', 'en', 'uz'];

export function categoryName(c: Category, locale: Locale): string {
  return pickLocalized(c.name, locale, c.slug);
}

export type { Locale };
